/* eslint-disable no-plusplus,no-restricted-syntax,no-shadow */
import dayjs from 'dayjs';
import { isEmpty, isNil } from 'ramda';
import { toastr } from 'react-redux-toastr';
import { I18n } from 'src/translations/i18n';

import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';
import { loadExcelExport } from './excelActions';

export const REQUEST = 'LOAD_PROJECTS_BY_JOBS_REQUEST';
export const SUCCESS = 'LOAD_PROJECTS_BY_JOBS_SUCCESS';
export const FAIL = 'LOAD_PROJECTS_BY_JOBS_FAIL';


const loadProjectsByJobsRequest = () => ({ type: REQUEST });

const loadProjectsByJobsSuccess = (worksInDepartments) => ({ type: SUCCESS, worksInDepartments });

const loadProjectsByJobsFail = (error) => ({ type: FAIL, error });

export const loadProjectsByJobs = (props = {}) => (dispatch) => {
  dispatch(loadProjectsByJobsRequest());
  return communicate({
    url: 'Reports/ProjectsByJobs',
    method: 'get',
    getParams: Utils.objects.getQueryStringFromObject({
      ...props,
      currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
    }) // '?period=2017-11-14,2017-11-14&departmentIds=&userIds=&jobIds=&workShiftIds=&wccIds='
  }).then(({ data }) => {
    if (isNil(data.Data) || isEmpty(data.Data)) {
      toastr.error(I18n.t('NoDataAvailable'));
      dispatch(loadProjectsByJobsSuccess([]));
    } else {
      dispatch(loadProjectsByJobsSuccess(data.Data));
    }
  }).catch((error) => {
    dispatch(loadProjectsByJobsFail(error));
    toastrError(error);
  });
};

export const loadExcel = (params) => (dispatch) => {
  const request = {
    url: 'Reports/ProjectsWorkTimesByJobsExcel',
    query: Utils.objects.getQueryStringFromObject({
      ...params,
      currentDateTime: dayjs().format('YYYY-MM-DD[T]HH:mm:ss')
    })
  };
  return dispatch(loadExcelExport(request));
};
